"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var _modal_1 = tslib_1.__importDefault(require("../_components/_modal"));
var button_1 = tslib_1.__importDefault(require("../button"));
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var PromptCloseCircleFill_1 = require("../Icons/PromptCloseCircleFill");
var PromptErrorFill_1 = require("../Icons/PromptErrorFill");
var PromptInfoCircleFill_1 = require("../Icons/PromptInfoCircleFill");
var PromptWarningCircleFill_1 = require("../Icons/PromptWarningCircleFill");
var getConfig = function (type, content, title, onConfirm, okText) {
    var colorMap = {
        success: '#00B42B',
        warn: '#FF7D00',
        error: '#FF2424',
    };
    var iconStyle = {
        color: colorMap[type || 'success'],
        fontSize: 40,
    };
    var icon = react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { style: iconStyle });
    switch (type) {
        case 'success':
            icon = react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { style: iconStyle });
            break;
        case 'warn':
            icon = react_1.default.createElement(PromptWarningCircleFill_1.PromptWarningCircleFill, { style: iconStyle });
            break;
        case 'error':
            icon = react_1.default.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, { style: iconStyle });
            break;
        default:
            break;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "anq-modal-wrapper" },
            react_1.default.createElement("div", { className: "anq-modal-icon" }, icon),
            react_1.default.createElement("div", { className: "info-modal-title" }, title),
            react_1.default.createElement("div", { className: "anq-modals-container" }, content)),
        react_1.default.createElement("div", { className: "modal-button-style" },
            react_1.default.createElement(button_1.default, { type: "primary", onClick: onConfirm }, okText))));
};
var getConfirmConfig = function (type, content, title, onConfirm, onCancelModal, okText, cancelText) {
    var colorMap = {
        confirm: '#FF7D00',
        delete: '#FF7D00',
        info: '#4C67FF',
    };
    var icon;
    var iconStyle = {
        color: colorMap[type],
        marginRight: 8,
        fontSize: 20,
        marginTop: 2,
        verticalAlign: 'middle',
    };
    switch (type) {
        case 'confirm':
        case 'delete':
            icon = react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { style: iconStyle });
            break;
        case 'info':
            icon = react_1.default.createElement(PromptInfoCircleFill_1.PromptInfoCircleFill, { style: iconStyle });
            break;
        default:
            icon = react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { style: iconStyle });
            break;
    }
    return (react_1.default.createElement("div", { className: "anq-modal-root" },
        react_1.default.createElement("div", { className: "anq-flex-style" },
            icon,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "anq-flex-style modal-content" },
                    react_1.default.createElement("div", { className: "info-modal-title" }, title),
                    content && react_1.default.createElement("div", { className: "anq-modal-containers" }, content)))),
        type === 'confirm' && (react_1.default.createElement("div", { className: "anq-modal-foot" },
            react_1.default.createElement(button_1.default, { type: "primary", onClick: onConfirm }, okText),
            react_1.default.createElement(button_1.default, { type: "default", className: "anq-cancle", onClick: onCancelModal }, cancelText))),
        type === 'delete' && (react_1.default.createElement("div", { className: "anq-modal-foot" },
            react_1.default.createElement(button_1.default, { type: "primary", danger: true, onClick: onConfirm }, okText || '确定删除'),
            react_1.default.createElement(button_1.default, { type: "default", className: "anq-cancle", onClick: onCancelModal }, cancelText || '取消'))),
        type === 'info' && (react_1.default.createElement("div", { className: "anq-modal-foot" },
            react_1.default.createElement(button_1.default, { type: "primary", onClick: onConfirm }, okText || '确定')))));
};
var AnqDelayModal = function (params) {
    var modalType = params.modalType, title = params.title, content = params.content, onConfirm = params.onConfirm, onCancelModal = params.onCancelModal, _a = params.okText, okText = _a === void 0 ? modalType === 'delete' ? '确定删除' : '确定' : _a, _b = params.cancelText, cancelText = _b === void 0 ? '取消' : _b, _c = params.width, width = _c === void 0 ? 400 : _c, rest = tslib_1.__rest(params, ["modalType", "title", "content", "onConfirm", "onCancelModal", "okText", "cancelText", "width"]);
    var type = modalType;
    var contentChild;
    switch (type) {
        case 'success':
        case 'warn':
        case 'error':
            contentChild = getConfig(type, content, title, onConfirm, okText);
            break;
        case 'info':
        case 'delete':
        case 'confirm':
            contentChild = getConfirmConfig(type, content, title, onConfirm, onCancelModal, okText, cancelText);
            break;
        default:
            break;
    }
    return (react_1.default.createElement(_modal_1.default, tslib_1.__assign({ centered: true }, rest, { width: width, footer: null, closable: false }),
        react_1.default.createElement(react_1.default.Fragment, null, contentChild)));
};
exports.default = AnqDelayModal;
//# sourceMappingURL=anqInfoModal.js.map